/**
 * @generated SignedSource<<93650747ec5a46167f883cf9603ff035>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OpsLayoutQuery$variables = Record<PropertyKey, never>;
export type OpsLayoutQuery$data = {
  readonly viewer: {
    readonly admin: boolean;
    readonly id: string;
    readonly image: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type OpsLayoutQuery = {
  response: OpsLayoutQuery$data;
  variables: OpsLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "admin",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsLayoutQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OpsLayoutQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b49a700d0f4bbd45af6d6b3f8971edf9",
    "id": null,
    "metadata": {},
    "name": "OpsLayoutQuery",
    "operationKind": "query",
    "text": "query OpsLayoutQuery {\n  viewer {\n    id\n    name\n    image\n    admin\n  }\n}\n"
  }
};
})();

(node as any).hash = "054f8cc306f0693aed4cf25a73419cf9";

export default node;
